var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowToright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Allow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8144 12L7.14047 3.77625C6.95992 3.60508 6.9526 3.32025 7.12412 3.14006C7.29564 2.95988 7.58104 2.95258 7.76158 3.12375L16.7796 11.6738C16.9667 11.8512 16.9667 12.1488 16.7796 12.3263L7.76158 20.8762C7.58104 21.0474 7.29564 21.0401 7.12412 20.8599C6.9526 20.6798 6.95992 20.3949 7.14046 20.2237L15.8144 12Z",
    fill: "#4C4948"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToright);
export default __webpack_public_path__ + "static/media/arrow_toright.9cbe73ffa404dae66da500b184e2359d.svg";
export { ForwardRef as ReactComponent };